import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';

import ModalDealLost from '../modal/modalDealLost';
import ModalTaskPost from '../modal/modalTaskPost';
import ModalAppointmentPost from '../modal/modalAppointmentPost';
import ModalReminderPost from '../modal/modalReminderPost';
import ModalNotePost from '../modal/modalNotePost';
import { appendGraphQlPlanning } from 'src/utils/utilPlanning';
import { deleteEntity, duplicateEntity } from 'src/utils/entityApi';
import MyPlanning from '../../appPlanning/myPlanning';
import InputUpdate from '../input/inputUpdate';
import ModalReturnEmployee from '../modal/modalReturnEmployee';
import ModalConfirm from '../modal/modalConfirm';
import ModalDealInterlocutor from '../modal/modalDealInterlocutor';
import DatePicker from 'react-bootstrap-date-picker';
import bookIcon from 'src/images/icons/003-book.svg';
import clerkWithTieIcon from 'src/images/icons/002-clerk-with-tie.svg';
import SubNavBar from '../SubNavBar';
import EmployeeSelect from './components/EmployeeSelect';
import ModalDuplicateDeal from 'src/scenes/components/modal/modalDuplicateDeal';
import ExternalLinkButton from 'src/scenes/components/display/components/ExternalLinkButton';
import PreparationToInstallationModal from 'src/scenes/components/modal/PreparationToInstallationModal';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const linkToContact = '/dashboard/contact/';
const linkToCustomer = '/dashboard/customer/';
const linkToUser = '/dashboard/user/';

const apiTask = '/api/task/';
const apiAppointment = '/api/appointment/';
const apiReminder = '/api/reminder/';
const apiNote = '/api/note/';

const apiIncDeal = '/api/deal/incrementStep/';
const apiOrigin = '/api/origin/';
const apiDealType = '/api/dealType/';
const apiDomainType = '/api/domains/';
const apiAgencyType = '/api/agency/';

const incrementInfos = {
  1: {
    message: 'Vous allez passer au BDC',
    needEmployee: false,
  },
  2: {
    message: 'Vous allez passer au Dossier prod',
    needEmployee: false,
  },
  3: {
    message:
      "Vous allez faire passer l'affaire en prod. \n \n Veuillez sélectionner la personne en charge de la commande. Note: la proposition commerciale est toujours modifiable",
    needEmployee: true,
  },
  4: {
    message:
      "Vous allez faire passer l'affaire en préparation. \n Important: Il ne sera plus possible de modifier le contenu de la proposition commerciale \n Veuillez sélectionner la personne en charge de la préparation.",
    needEmployee: true,
  },
  5: {
    message:
      "Vous allez faire passer l'affaire en installation. \n Veuillez sélectionner la personne en charge de l'installation.",
    needEmployee: true,
  },
};

class DisplayDeal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fatalError: undefined,
      isImported: false,
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      isModalConfirmIncrement: false,
      isModalReturnEmployee: false,
      isModalLostDealOpen: false,
      isModalDeleteDealOpen: false,
      isModalDuplicateDealOpen: false,
      isModalStandByDealOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      isModalDealChangeOpen: false,
      isModalRemoveInterlocutorOpen: false,
      isModalPreparationToInstallationOpen: false,
      isModalAddInterlocutorOpen: false,
      toAssociate: {
        type: 'deal',
      },
      selectedView: 1,
      currentStep: 1,
      entity: undefined,
      dealId: undefined,
      dealName: undefined,
      customer: undefined,
      contact: undefined,
      dataOrigin: undefined,
      dataTypes: undefined,
      dealType: undefined,
      dealAgencyId: undefined,
      dateCreate: '____',
      desiredClotureDate: moment().format('YYYY-MM-DD'),
      contractEndDate: '',
      PDC: '____',
      isLost: false,
      textModal: {
        title: 'Étape suivante',
        message: "Vous allez faire passer l'affaire à l'étape suivante",
      },
      dealChangeGraphKey: undefined,
      dealChangeNewState: undefined,
      dealInterlocutors: undefined,
      interlocutorToRemoveId: undefined,
      domainTypes: undefined,
      originAgency: '0',
      agencyTypes: [{ id: 0, name: 'France' }],
      domainId: undefined,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
    this.goNextStep = this.goNextStep.bind(this);
    this.switchStep = this.switchStep.bind(this);
    this.incStep = this.incStep.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.postResult = this.postResult.bind(this);
    this.updateField = this.updateField.bind(this);
    this.handleDealChange = this.handleDealChange.bind(this);
    this.updateDealRequest = this.updateDealRequest.bind(this);
    this.removeInterlocutor = this.removeInterlocutor.bind(this);
    this.linkInterlocutorResult = this.linkInterlocutorResult.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleDealChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'origin') {
      this.openModalDealChange('originId', value);
    } else if (name === 'commercialEmployee') {
      this.openModalDealChange('commercialEmployeeId', value);
    } else if (name === 'dealType') {
      this.openModalDealChange('dealTypeId', value);
    } else if (name === 'domainId') {
      this.openModalDealChange('domainId', value);
    }
  }

  openModalDealChange(graphKey, newState) {
    let modal = {
      title: 'Affaire',
      message: "Vous allez modifier l'affaire",
    };
    this.props.toggleBlackOut();
    this.setState({
      textModal: modal,
      isModalDealChangeOpen: true,
      dealChangeGraphKey: graphKey,
      dealChangeNewState: newState,
    });
  }

  filterDealTypesByDomain = (dealTypes = [], domainId) => {
    if (!domainId) {
      return dealTypes;
    }
    return dealTypes.filter((dealType) => (dealType.domain || {}).id === domainId);
  };

  updateDealRequest() {
    if (this.state.dealId && this.state.dealChangeGraphKey && this.state.dealChangeNewState) {
      let queryURL = apiDealShow;
      let graphQL =
        'mutation{ deal(id:' +
        this.state.dealId +
        ',' +
        this.state.dealChangeGraphKey +
        ':' +
        this.state.dealChangeNewState +
        ' ){ id } }';
      queryURL += graphQL;

      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['deal']) {
            this.componentDidMount();
            this.props.openToast(true, "L'affaire a été modifié");
          } else {
            const message = ((data['errors'] || [])[0] || {}).message;
            this.props.openToast(false, message || 'Erreur modification affaire. Veuillez réessayer');
          }
        })
        .catch((rror) => {
          console.log(rror);
        });
    }
  }

  getDomainTypes() {
    let queryURL = apiDomainType;
    let graphQL = '{ domains{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            domainTypes: data['data']['domains'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch domain types');
        }.bind(this)
      );
  }

  deleteCollaborative = (id, type) => {
    let json = { [type]: { id } };

    let collaborative = {
      type: undefined,
      message: undefined,
      apiUrl: undefined,
    };

    let afterView = 1;
    switch (type) {
      case 'task':
        collaborative.type = 'task';
        collaborative.message = 'tâche';
        collaborative.apiUrl = apiTask;
        afterView = 1;
        break;
      case 'appointment':
        collaborative.type = 'appointment';
        collaborative.message = 'rendez-vous';
        collaborative.apiUrl = apiAppointment;
        afterView = 2;
        break;
      case 'reminder':
        collaborative.type = 'reminder';
        collaborative.message = 'rappel';
        collaborative.apiUrl = apiReminder;
        afterView = 3;
        break;
      case 'note':
        collaborative.type = 'note';
        collaborative.message = 'note';
        collaborative.apiUrl = apiNote;
        afterView = 4;
        break;
    }

    let queryURL = collaborative.apiUrl;
    let tabParam = encodeURIComponent(JSON.stringify(json));
    queryURL += tabParam;

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.isValid) {
          this.componentDidMount();
          this.setState({ selectedView: afterView });
          this.props.openToast(true, 'Suppression réalisée ');
        } else {
          this.props.openToast(false, 'Erreur suppression. Veuillez réessayer');
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.openToast(false, 'Impossible à supprimer');
      });
  };

  getAgencyTypes() {
    let queryURL = apiAgencyType;
    let graphQL = '{ agencies{id, name} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          agencyTypes: [{ id: 0, name: 'France' }, ...data['data']['agencies']],
        });
      })
      .catch((error) => {
        console.log('erreur fetch agency types');
      });
  }

  getOrigins() {
    let queryURL = apiOrigin;
    let graphQL = `{ origins{ id, labelOrigin, active, agency{ id }}}`;
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          this.setState({
            dataOrigin: data['data']['origins'],
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch origins: \n' + error);
        }.bind(this)
      );
  }

  getDealTypes() {
    let queryURL = apiDealType;
    let graphQL = '{ dealTypes{id, name, active, domain{id, name}} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then((data) => {
        this.setState({
          dataTypes: (data['data']['dealTypes'] || []).filter((type) => type.active),
        });
      })
      .catch((error) => {
        console.log('erreur fetch deal types');
      });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      this.setState({ fatalError: undefined });

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id, sugarId, name, lost, standBy, deleted, dateCreate, desiredClotureDate, contractEndDate, agency{ id }, origin{ id, labelOrigin}, ' +
        'customer{ id, installationSite{ socialReason }, ' +
        'triggerContact{ id, name, lastname }, contacts{ id, name, lastname}, externalContacts{ id, name, lastname} }, ' +
        'stepCommercial{ id, intermediateStageNumber, proposition{ id, pdc }, fileForProd{ orderForm{ id, name }, exOperatorBills{ id, name } }, commercialEmployee{ id, user{ id, username } } }, ' +
        'stepProd{ id, intermediateStageNumber, dealOrder{ salesAssistant{ user{ id, username } } }, preparation{ orderPicker{ user{ id, username } }, installation{ provider{ id, name }, installer{ user{ id, username } } } } }, ' +
        'stepAdministrative{ id, intermediateStageNumber, billmakerEmployee{ user{ id, username } } }, ' +
        'stepSupport{ id, intermediateStageNumber} ' +
        'interlocutors{ id, name, lastname}' +
        'domain {id, name}, ' +
        'type {id, name}' +
        appendGraphQlPlanning() +
        '} }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then((data) => {
          let pdc = 'Pas encore défini';
          if (data['data']['deal']) {
            // Associate relative planning
            let toAssociate = this.state.toAssociate;
            toAssociate['id'] = data['data']['deal']['id'];
            toAssociate['name'] = data['data']['deal']['name'];
            // Get the step
            let currentStep = 0;
            if (data['data']['deal']['stepCommercial']) {
              currentStep += data['data']['deal']['stepCommercial']['intermediateStageNumber'];
              if (data['data']['deal']['stepCommercial']['proposition']) {
                pdc = data['data']['deal']['stepCommercial']['proposition']['pdc'] + '€';
              }
            }
            if (data['data']['deal']['stepProd']) {
              currentStep += data['data']['deal']['stepProd']['intermediateStageNumber'];
            }
            if (data['data']['deal']['stepAdministrative']) {
              currentStep += data['data']['deal']['stepAdministrative']['intermediateStageNumber'];
            }
            if (data['data']['deal']['stepSupport']) {
              currentStep += data['data']['deal']['stepSupport']['intermediateStageNumber'];
            }
            // set current view
            let currentView;
            if (currentStep < 4) {
              currentView = 1;
            } else if (currentStep < 7) {
              currentView = 2;
            } else if (currentStep < 8) {
              currentView = 3;
            } else {
              currentView = 4;
            }
            this.setState({
              currentStep: currentStep,
              selectedView: currentView,
              entity: data['data']['deal'],
              dealId: data['data']['deal']['id'],
              commercialEmployeeId: data['data']['deal']['stepCommercial']['commercialEmployee']['id'],
              isImported: !!data['data']['deal']['sugarId'],
              dealName: data['data']['deal']['name'],
              customer: data['data']['deal']['customer'],
              origin: data['data']['deal']['origin'],
              dateCreate: data['data']['deal']['dateCreate'],
              desiredClotureDate: data['data']['deal']['desiredClotureDate'] || moment().format('YYYY-MM-DD'),
              contractEndDate: data['data']['deal']['contractEndDate'] || '',
              domainId: (data['data']['deal']['domain'] || {})['id'] || 1,
              PDC: pdc,
              isLost: data['data']['deal']['lost'],
              isStandBy: data['data']['deal']['standBy'],
              isDeleted: data['data']['deal']['deleted'],
              dataTask: data['data']['deal']['tasks'],
              dataAppointment: data['data']['deal']['appointments'],
              dataReminder: data['data']['deal']['reminders'],
              dataNote: data['data']['deal']['notes'],
              dealType: data['data']['deal']['type'],
              dealInterlocutors: data['data']['deal']['interlocutors'],
              dealAgencyId: data['data']['deal']['agency']['id'],
            });

            this.getOrigins();
            this.getAgencyTypes();
          } else {
            let message = "Erreur lors de la récupération de l'affaire";

            if (data['errors'] && data['errors'].length > 0) {
              message = data['errors'].map((e) => e.message).join(', ');
            }

            throw new Error(message);
          }
        })
        .catch((error) => {
          this.setState({ fatalError: error.message });
        });

      this.getDomainTypes();
      this.getDealTypes();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      // Route reloaded
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  handleOriginAgencyChange = (val) => {
    this.setState({ originAgency: val.target.value });
  };

  filterOriginsByAgency = () => {
    if (this.state.originAgency && this.state.originAgency !== '0') {
      return this.state.dataOrigin.filter(
        (originType) => `${(originType.agency || {}).id}` === this.state.originAgency
      );
    }

    return this.state.dataOrigin;
  };

  getProviderInCharge = () => {
    const stepProd = this.state.entity.stepProd || {};
    const installation = (stepProd.preparation || {}).installation || {};

    return installation.provider || {};
  };

  getEmployeeInCharge(stepNumber) {
    let res = undefined;
    switch (stepNumber) {
      case 1: // Proposal
        res = this.state.entity['stepCommercial']['commercialEmployee']
          ? this.state.entity['stepCommercial']['commercialEmployee']['user']
          : undefined;
        break;
      case 2: // OrderForm
        res = this.state.entity['stepCommercial']['commercialEmployee']
          ? this.state.entity['stepCommercial']['commercialEmployee']['user']
          : undefined;
        break;
      case 3: // Dossier
        res = this.state.entity['stepCommercial']['commercialEmployee']
          ? this.state.entity['stepCommercial']['commercialEmployee']['user']
          : undefined;
        break;
      case 4: // Production
        res =
          this.state.entity['stepProd']['dealOrder'] && this.state.entity['stepProd']['dealOrder']['salesAssistant']
            ? this.state.entity['stepProd']['dealOrder']['salesAssistant']['user']
            : undefined;
        break;
      case 5: // Preparation
        res =
          this.state.entity['stepProd']['preparation'] && this.state.entity['stepProd']['preparation']['orderPicker']
            ? this.state.entity['stepProd']['preparation']['orderPicker']['user']
            : undefined;
        break;
      case 6: // Installation
        res =
          this.state.entity['stepProd']['preparation'] &&
          this.state.entity['stepProd']['preparation']['installation'] &&
          this.state.entity['stepProd']['preparation']['installation']['installer']
            ? this.state.entity['stepProd']['preparation']['installation']['installer']['user']
            : undefined;
        break;
      case 7: // Billing
        res =
          this.state.entity['stepAdministrative'] && this.state.entity['stepAdministrative']['billmakerEmployee']
            ? this.state.entity['stepAdministrative']['billmakerEmployee']['user']
            : undefined;
        break;
    }
    return res;
  }

  getActiveOrigin = () => {
    return Object.entries(this.filterOriginsByAgency()).filter(
      ([key, data]) => data.active || data.id === this.state.origin.id
    );
  };

  render() {
    const {
      dealId,
      dealName,
      origin,
      dealType,
      commercialEmployeeId,
      dealInterlocutors,
      customer,
      desiredClotureDate,
      contractEndDate,
    } = this.state;

    let routeID = '';
    if (this.props.match.params.id) {
      routeID = '/' + this.props.match.params.id;
    }

    let viewName = ' ';
    switch (this.state.selectedView) {
      case 1:
        viewName = 'Commercial';
        break;
      case 2:
        viewName = 'Production';
        break;
      case 3:
        viewName = 'Administratif';
        break;
      case 4:
        viewName = 'Support';
        break;
    }

    const deal = {
      id: dealId,
      name: dealName,
      origin,
      type: dealType,
      commercialEmployeeId,
      interlocutorIds: (dealInterlocutors || []).map((interlocutor) => interlocutor.id),
      customerId: (customer || {}).id,
      desiredClotureDate,
      contractEndDate,
      isLost: this.state.isLost,
    };

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title={`Fiche Affaire ${this.state.isImported ? 'importée sugar' : ''}`}
        >
          <div className={'appViewNavMenu-alignRight'}>
            <button onClick={() => this.openModal('task')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Tâche</span>
            </button>
            <button
              onClick={() => this.openModal('appointment')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Rdv</span>
            </button>
            <button onClick={() => this.openModal('reminder')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Rappel</span>
            </button>
            <button onClick={() => this.openModal('note')} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-plus'>Note</span>
            </button>
            <button
              onClick={() => this.openModal('add-interlocutor')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-plus'>Interlocuteur</span>
            </button>
            <button
              onClick={() => this.openModal('deal-loss')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              {this.state.isLost ? (
                <span className='icon icon-reply'>Réouvrir</span>
              ) : (
                <span className='icon icon-thumbs-down'>Perdu</span>
              )}
            </button>

            <button
              onClick={() => this.openModal('deal-delete')}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-cross'>Supprimer</span>
            </button>

            <button
              onClick={() => this.setState({ isModalDuplicateDealOpen: true, appViewNavExtended: false })}
              type='button'
              className='btn btn-sm btn-outline-success'
            >
              <span className='icon icon-copy'>Dupliquer</span>
            </button>

            {this.state.currentStep < 8 && (
              <button
                onClick={() => this.openModal('deal-standby')}
                type='button'
                className='btn btn-sm btn-outline-success'
              >
                <span className={'icon icon-' + (this.state.isStandBy ? 'controller-play ' : 'controller-paus ')}>
                  {this.state.isStandBy ? 'Relancer' : 'Stand-by'}
                </span>
              </button>
            )}
          </div>
        </SubNavBar>

        {!this.state.fatalError ? (
          <div id='appViewContent'>
            <div className='panel-deal-infos'>
              <div className='panel-deal-entity'>
                {this.state.entity && this.state.entity.name && (
                  <InputUpdate
                    inputType={'text'}
                    inputValue={this.state.entity.name}
                    submitUpdate={(inputValue) => this.updateField(inputValue, 'text', 'name')}
                    toggleBlackOut={() => this.props.toggleBlackOut()}
                  />
                )}
                <div className='alignHorizontal'>
                  <img src={bookIcon} alt='' />
                  {this.state.customer && this.state.customer.triggerContact ? (
                    <Link to={linkToContact + this.state.customer.triggerContact.id}>
                      <span>
                        {this.state.customer.triggerContact.name + ' ' + this.state.customer.triggerContact.lastname}
                      </span>
                    </Link>
                  ) : (
                    <span>Non-renseigné</span>
                  )}
                </div>
                <div className='alignHorizontal'>
                  <img src={clerkWithTieIcon} alt='' />
                  {this.state.customer ? (
                    <Link to={linkToCustomer + this.state.customer.id}>
                      <span>{this.state.customer.installationSite.socialReason}</span>
                    </Link>
                  ) : (
                    <span>Non-renseigné</span>
                  )}
                </div>
                {this.state.entity && this.state.entity['stepCommercial']['commercialEmployee'] && (
                  <div className={'alignHorizontal'}>
                    <span>Commercial:</span>
                    <EmployeeSelect
                      name='commercialEmployee'
                      className='form-control'
                      size='small'
                      legacyAgencyId={this.state.dealAgencyId}
                      value={this.state.entity['stepCommercial']['commercialEmployee']['id']}
                      onChange={this.handleDealChange}
                    />
                  </div>
                )}
                {this.state.entity && (
                  <div className={'alignHorizontal'}>
                    <p>Interlocuteur(s):</p>
                  </div>
                )}
                {this.state.entity &&
                  this.state.dealInterlocutors &&
                  this.state.dealInterlocutors.map((data, key) => (
                    <div key={key} className={'alignHorizontal'}>
                      <li className='' key={data.id}>
                        <Link to={linkToContact + data.id}>
                          <span>{data.name + ' ' + data.lastname}</span>
                        </Link>
                        <button
                          onClick={() => this.openModal('remove-interlocutor', data)}
                          type='button'
                          className='btn btn-sm btn-outline-success'
                        >
                          <span className='icon icon-cross' />
                        </button>
                      </li>
                    </div>
                  ))}
              </div>
              <div className='panel-deal-entity'>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  Date création: {moment(this.state.dateCreate).format('DD-MM-YYYY')}
                  <div>
                    <InputUpdate
                      style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}
                      inputLabel='Clôture désirée: '
                      inputValue={moment(this.state.desiredClotureDate).format('YYYY-MM-DD')}
                      renderInput={(props) => (
                        <DatePicker
                          {...props}
                          calendarContainer={this}
                          showClearButton={false}
                          style={{}}
                          name='desiredClotureDate'
                          dateFormat='DD-MM-YYYY'
                        />
                      )}
                      submitUpdate={(inputValue) =>
                        this.updateField(moment(inputValue).format('YYYY-MM-DD HH:mm:ss'), 'text', 'desiredClotureDate')
                      }
                      toggleBlackOut={() => this.props.toggleBlackOut()}
                    />
                  </div>
                </div>

                <div>
                  <InputUpdate
                    style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}
                    inputLabel="Date de fin d'engagement: "
                    inputValue={
                      this.state.contractEndDate && this.state.contractEndDate.length > 0
                        ? moment(this.state.contractEndDate).format('YYYY-MM-DD')
                        : ''
                    }
                    renderInput={(props) => (
                      <DatePicker
                        {...props}
                        calendarContainer={this}
                        showClearButton={false}
                        style={{}}
                        name='contractEndDate'
                        dateFormat='DD-MM-YYYY'
                      />
                    )}
                    submitUpdate={(inputValue) =>
                      this.updateField(moment(inputValue).format('YYYY-MM-DD HH:mm:ss'), 'text', 'contractEndDate')
                    }
                    toggleBlackOut={() => this.props.toggleBlackOut()}
                  />
                </div>

                <div className='alignHorizontal'>
                  <span>{'PDC: ' + this.state.PDC}</span>
                </div>
                {this.state.dealType && (
                  <div className={'alignHorizontal'}>
                    <span>Type:</span>
                    <select
                      name='dealType'
                      value={this.state.dealType.id}
                      onChange={this.handleDealChange}
                      className='form-control'
                    >
                      {this.state.dataTypes ? (
                        Object.entries(this.filterDealTypesByDomain(this.state.dataTypes, this.state.domainId)).map(
                          ([key, data]) => (
                            <option key={key} value={data.id}>
                              {data.name}
                            </option>
                          )
                        )
                      ) : (
                        <span>Chargement...</span>
                      )}

                      {this.state.dealType &&
                        this.state.dataTypes &&
                        this.state.dataTypes.filter((type) => type.id === this.state.dealType.id).length === 0 && (
                          <option value={this.state.dealType.id}>{this.state.dealType.name}</option>
                        )}
                    </select>
                  </div>
                )}

                <div className={'alignHorizontal'}>
                  <span>Domaine:</span>
                  <select
                    name='domainId'
                    value={this.state.domainTypes ? this.state.domainId : 'none'}
                    onChange={this.handleDealChange}
                    className='form-control'
                  >
                    <option disabled value={'none'} />
                    {this.state.domainTypes ? (
                      Object.entries(this.state.domainTypes).map(([key, data]) => (
                        <option key={key} value={data.id}>
                          {data.name}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>

                <div className={'alignHorizontal'}>
                  <label>Filtrer&nbsp;les&nbsp;origines&nbsp;par&nbsp;agence:</label>
                  <select
                    name='originAgency'
                    value={this.state.originAgency}
                    onChange={this.handleOriginAgencyChange}
                    className='form-control'
                  >
                    {this.state.agencyTypes ? (
                      this.state.agencyTypes.map((data, key) => (
                        <option key={key} value={data.id}>
                          {data.name}
                        </option>
                      ))
                    ) : (
                      <span>Chargement...</span>
                    )}
                  </select>
                </div>

                {this.state.origin && (
                  <div className={'alignHorizontal'}>
                    <span>Origine:</span>
                    <select
                      name='origin'
                      value={this.state.origin.id}
                      onChange={this.handleDealChange}
                      className='form-control'
                    >
                      {this.state.dataOrigin ? (
                        this.getActiveOrigin().map(([key, data]) => (
                          <option key={key} value={data.id}>
                            {data.labelOrigin}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>
                )}

                {(this.state.isDeleted || this.state.isLost || this.state.isStandBy) && (
                  <div className='alignHorizontal'>
                    <span
                      className={
                        'icon icon-' +
                        (this.state.isDeleted ? 'cross ' : this.state.isLost ? 'thumbs-down ' : 'controller-paus ')
                      }
                    >
                      Affaire {this.state.isDeleted ? 'supprimée' : this.state.isLost ? 'perdue' : 'en stand-by'}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className='timeline-step-name'>
              <h3>{viewName}</h3>
            </div>
            <div
              className={
                'timeline ' +
                (this.state.currentStep < 4 ? 'step1 ' : '') +
                (this.state.currentStep >= 4 ? 'step2 ' : '') +
                (this.state.currentStep >= 7 ? 'step3 ' : '') +
                (this.state.currentStep >= 8 ? 'step4 ' : '')
              }
            >
              <div className='timeline-flex'>
                <div
                  onClick={(newStep) => this.switchStep(1)}
                  className={'prep-step-number ' + (this.state.selectedView == 1 ? 'selected' : '')}
                >
                  <span>1</span>
                </div>
                <div
                  onClick={(newStep) => this.switchStep(2)}
                  className={'prep-step-number ' + (this.state.selectedView == 2 ? 'selected' : '')}
                >
                  <span>2</span>
                </div>
                <div
                  onClick={(newStep) => this.switchStep(3)}
                  className={'prep-step-number ' + (this.state.selectedView == 3 ? 'selected' : '')}
                >
                  <span>3</span>
                </div>
                <div
                  onClick={(newStep) => this.switchStep(4)}
                  className={'prep-step-number ' + (this.state.selectedView == 4 ? 'selected' : '')}
                >
                  <span>4</span>
                </div>
              </div>
            </div>
            <div className='alignHorizontal table-head'>
              <span className='panel-stepview-col0' />
              <span className='panel-stepview-col1'>
                <b>{this.state.selectedView == 4 ? 'En Cours' : 'Etat'}</b>
              </span>
              <span className='panel-stepview-col2'>
                <b>{this.state.selectedView == 4 ? 'Résolus' : 'En Charge'}</b>
              </span>
            </div>
            {this.state.selectedView == 1 && (
              <div className='panel-stepview'>
                <div className='alignHorizontal panel-stepview-row '>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 1
                        ? '/dashboard/proposal' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Proposition</span>
                  </Link>
                  {this.state.currentStep > 1 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 1 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 1 && this.state.entity && this.getEmployeeInCharge(1) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(1).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(1).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                  {this.state.currentStep == 1 && (
                    <button
                      onClick={() => this.openModal('increment')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-arrow-right'>Suivant</span>
                    </button>
                  )}
                </div>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 2
                        ? '/dashboard/orderform' + routeID
                        : '/notfound'
                    }
                  >
                    <span>BDC</span>
                  </Link>
                  {this.state.currentStep > 2 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 2 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 2 && this.state.entity && this.getEmployeeInCharge(2) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(2).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(2).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                  {this.state.currentStep == 2 && (
                    <button
                      onClick={() => this.openModal('increment')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-arrow-right'>Suivant</span>
                    </button>
                  )}
                </div>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 3
                        ? '/dashboard/dossier' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Dossier production</span>
                  </Link>
                  {this.state.currentStep > 3 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 3 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 3 && this.state.entity && this.getEmployeeInCharge(3) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(3).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(3).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                  {this.state.currentStep == 3 && (
                    <button
                      onClick={() => this.openModal('increment')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-arrow-right'>Suivant</span>
                    </button>
                  )}
                </div>
              </div>
            )}
            {this.state.selectedView == 2 && (
              <div className='panel-stepview'>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 4
                        ? '/dashboard/production' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Commande</span>
                  </Link>
                  {this.state.currentStep > 4 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 4 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 4 && this.state.entity && this.getEmployeeInCharge(4) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(4).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(4).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                  {this.state.currentStep == 4 && (
                    <button
                      onClick={() => this.openModal('increment')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-arrow-right'>Suivant</span>
                    </button>
                  )}
                </div>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 5
                        ? '/dashboard/preparation' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Préparation</span>
                  </Link>
                  {this.state.currentStep > 5 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 5 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 5 && this.state.entity && this.getEmployeeInCharge(5) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(5).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(5).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                  {this.state.currentStep == 5 && (
                    <button
                      onClick={() => this.openModal('increment')}
                      type='button'
                      className='btn btn-sm btn-outline-success'
                    >
                      <span className='icon icon-arrow-right'>Suivant</span>
                    </button>
                  )}
                </div>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 6 ? '/dashboard/setup' + routeID : '/notfound'
                    }
                  >
                    <span>Installation</span>
                  </Link>
                  {this.state.currentStep > 6 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep === 6 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 6 && this.state.entity ? (
                    this.getEmployeeInCharge(6) ? (
                      <Link to={linkToUser + this.getEmployeeInCharge(6).id}>
                        <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(6).username}</span>
                      </Link>
                    ) : (
                      <span className='panel-stepview-col2'>{this.getProviderInCharge().name || '_______'}</span>
                    )
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                </div>

                {this.state.currentStep >= 6 && (
                  <ExternalLinkButton providerId={this.getProviderInCharge().id} dealId={this.state.dealId} />
                )}
              </div>
            )}
            {this.state.selectedView == 3 && (
              <div className='panel-stepview'>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 6
                        ? '/dashboard/billing' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Facturation</span>
                  </Link>
                  {this.state.currentStep > 7 ? (
                    <span className='panel-stepview-col1'>Validé</span>
                  ) : this.state.currentStep >= 6 ? (
                    <span className='panel-stepview-col1'>En cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep >= 7 && this.state.entity && this.getEmployeeInCharge(7) ? (
                    <Link to={linkToUser + this.getEmployeeInCharge(7).id}>
                      <span className='panel-stepview-col2'>{'@' + this.getEmployeeInCharge(7).username}</span>
                    </Link>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                </div>
              </div>
            )}
            {this.state.selectedView == 4 && (
              <div className='panel-stepview'>
                <div className='alignHorizontal panel-stepview-row'>
                  <Link
                    className='panel-stepview-col0 '
                    to={
                      !this.state.isImported && this.state.currentStep >= 6
                        ? '/dashboard/ticketlist' + routeID
                        : '/notfound'
                    }
                  >
                    <span>Historique Tickets</span>
                  </Link>
                  {this.state.currentStep > 8 ? (
                    <span className='panel-stepview-col1'>xxx en cours</span>
                  ) : (
                    <span className='panel-stepview-col1'>_______</span>
                  )}
                  {this.state.currentStep > 8 ? (
                    <span className='panel-stepview-col2'>xxx résolus</span>
                  ) : (
                    <span className='panel-stepview-col2'>_______</span>
                  )}
                </div>
              </div>
            )}

            <MyPlanning
              onEntity={true}
              dataTask={this.state.dataTask}
              dataAppointment={this.state.dataAppointment}
              dataReminder={this.state.dataReminder}
              dataNote={this.state.dataNote}
              deleteCollaborative={this.deleteCollaborative}
            />
          </div>
        ) : (
          <div className='alert alert-danger' role='alert'>
            {this.state.fatalError}
          </div>
        )}

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalConfirmIncrement}
          onSubmit={this.incStep}
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />

        <PreparationToInstallationModal
          className='myModal'
          isOpen={this.state.isModalPreparationToInstallationOpen}
          openToast={this.props.openToast}
          onSubmit={this.incStep}
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDeleteDealOpen}
          onSubmit={(type, promise) =>
            this.postResult('deal-delete', deleteEntity(this.props.authFetch, 'deal', dealId))
          }
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
        <ModalDuplicateDeal
          agencyId={this.state.dealAgencyId}
          originTypes={(this.state.dataOrigin || []).filter((origin) => origin.active)}
          dealTypes={this.filterDealTypesByDomain(this.state.dataTypes, this.state.domainId)}
          deal={deal}
          onValidate={(data) => this.postResult('deal-duplicate', duplicateEntity(this.props.authFetch, 'deal', data))}
          onClose={() => this.setState({ isModalDuplicateDealOpen: false })}
          isOpen={this.state.isModalDuplicateDealOpen}
        />
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalStandByDealOpen}
          onSubmit={(newValue, inputType, fieldName) => this.updateField(!this.state.isStandBy, 'boolean', 'standBy')}
          onCancel={this.closeModal}
          onClose={this.closeModal}
        />
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalDealChangeOpen}
          onSubmit={this.updateDealRequest}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />
        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalRemoveInterlocutorOpen}
          onSubmit={this.removeInterlocutor}
          onClose={this.closeModal}
          onCancel={this.closeModal}
        />

        <ModalReturnEmployee
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalReturnEmployee}
          openToast={this.props.openToast}
          onPostResult={(employeeId) => this.incStep(employeeId)}
          onClose={this.closeModal}
        />

        <ModalDealLost
          myDeal={deal}
          className='myModal'
          isOpen={this.state.isModalLostDealOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalTaskPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostTaskOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalAppointmentPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostAppointmentOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalReminderPost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostReminderOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalNotePost
          entityAssociated={this.state.toAssociate}
          className='myModal'
          isOpen={this.state.isModalPostNoteOpen}
          openToast={this.props.openToast}
          onPostResult={this.postResult}
          onClose={this.closeModal}
        />

        <ModalDealInterlocutor
          entityAssociated={this.state.entity}
          className='myModal'
          isOpen={this.state.isModalAddInterlocutorOpen}
          openToast={this.props.openToast}
          onLinkResult={this.linkInterlocutorResult}
          onClose={this.closeModal}
        />
      </div>
    );
  }

  incStep(employeeId = undefined, providerId = undefined) {
    if (!this.state.isImported && this.state.currentStep == 1 && !this.state.entity['stepCommercial']['proposition']) {
      // propal not saved
      this.props.openToast(false, 'Aucune propal sauvegardée');
    } else if (
      !this.state.isImported &&
      this.state.currentStep == 2 &&
      (!this.state.entity['stepCommercial']['fileForProd'] ||
        !this.state.entity['stepCommercial']['fileForProd']['orderForm'])
    ) {
      // orderform not saved
      this.props.openToast(false, 'Aucun BDC sauvegardé');
    } else {
      // Everything is valid -> we increment
      let json = {
        deal: {
          id: this.props.match.params.id,
        },
      };
      if (employeeId && employeeId !== -1) {
        json['employee'] = {
          id: employeeId,
        };
      }
      if (providerId && providerId !== -1) {
        json['provider'] = {
          id: providerId,
        };
      }

      let queryURL = apiIncDeal;
      queryURL += encodeURIComponent(JSON.stringify(json));
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'POST',
        })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.isValid) {
            this.props.openToast(true, "Passage à l'étape suivante");
            this.componentDidMount();
          } else {
            this.props.openToast(false, "Erreur passage à l'étape suivante");
          }
        });
    }
  }

  switchStep(newStep) {
    this.setState({
      selectedView: newStep,
    });
  }

  goNextStep() {
    if (this.state.currentStep <= 8) {
      this.setState({
        currentStep: this.state.currentStep + 1,
      });
    }
    if (this.state.currentStep == 4) {
      this.setState({
        selectedView: 2,
      });
    }
    if (this.state.currentStep == 7) {
      this.setState({
        selectedView: 3,
      });
    }
    if (this.state.currentStep == 8) {
      this.setState({
        selectedView: 4,
      });
    }
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalReturnEmployee: false,
      isModalPreparationToInstallationOpen: false,
      isModalConfirmIncrement: false,
      isModalLostDealOpen: false,
      isModalDeleteDealOpen: false,
      isModalStandByDealOpen: false,
      isModalPostTaskOpen: false,
      isModalPostAppointmentOpen: false,
      isModalPostReminderOpen: false,
      isModalPostNoteOpen: false,
      isModalDealChangeOpen: false,
      isModalRemoveInterlocutorOpen: false,
      isModalAddInterlocutorOpen: false,
    });
  }

  openModal(type, entity = null) {
    let toOpen = undefined;
    switch (type) {
      case 'increment':
        let currIncrement = incrementInfos[this.state.currentStep];
        this.setState({
          textModal: {
            title: this.state.textModal.title,
            message: currIncrement.message,
          },
        });

        if (this.state.currentStep === 5) {
          toOpen = 'isModalPreparationToInstallationOpen';
        } else {
          toOpen = currIncrement.needEmployee ? 'isModalReturnEmployee' : 'isModalConfirmIncrement';
        }
        break;
      case 'deal-loss':
        toOpen = 'isModalLostDealOpen';
        break;
      case 'deal-standby':
        this.setState({
          textModal: {
            title: 'Stand-by',
            message: "Vous allez modifier l'état de cette affaire.",
          },
        });
        toOpen = 'isModalStandByDealOpen';
        break;
      case 'deal-delete':
        this.setState({
          textModal: {
            title: 'Supprimer',
            message: 'Vous allez supprimer cette affaire.',
          },
        });
        toOpen = 'isModalDeleteDealOpen';
        break;
      case 'task':
        toOpen = 'isModalPostTaskOpen';
        break;
      case 'appointment':
        toOpen = 'isModalPostAppointmentOpen';
        break;
      case 'reminder':
        toOpen = 'isModalPostReminderOpen';
        break;
      case 'note':
        toOpen = 'isModalPostNoteOpen';
        break;
      case 'add-interlocutor':
        toOpen = 'isModalAddInterlocutorOpen';
        break;
      case 'remove-interlocutor':
        toOpen = 'isModalRemoveInterlocutorOpen';
        let modalText = {
          title: 'Retirer interlocuteur ',
          message: "Vous allez retirer l'interlocuteur ",
        };
        this.setState({
          textModal: modalText,
          interlocutorToRemoveId: entity.id,
        });
        break;
    }
    this.props.toggleBlackOut();
    this.setState({
      currentCollaborativeType: type,
      [toOpen]: true,
      appViewNavExtended: false,
    });
  }

  postResult(type, promise) {
    let messageLabel = 'entité';
    switch (type) {
      case 'deal-loss':
        messageLabel = this.state.isLost ? 'Affaire réouverte' : 'Passé en perdu';
        break;
      case 'deal-delete':
        messageLabel = 'Affaire supprimée';
        break;
      case 'deal-duplicate':
        messageLabel = 'Affaire dupliquée';
        break;
      case 'task':
        messageLabel = 'Succès création tâche';
        break;
      case 'appointment':
        messageLabel = 'Succès création rdv';
        break;
      case 'reminder':
        messageLabel = 'Succès création rappel';
        break;
      case 'note':
        messageLabel = 'Succès création note';
        break;
    }
    promise.then((result) => {
      if (result.wentFine) {
        this.props.openToast(true, messageLabel);
        this.componentDidMount();
      } else {
        this.props.openToast(false, result.data || 'Une erreur est survenue. Veuillez réessayer');
      }
    });
  }

  updateField(newValue, inputType, fieldName) {
    // !! Important-> the given "fieldName" attribute must be the name of the ORM attribute !!
    let newValueSent;
    if (inputType == 'text') {
      newValueSent = '"' + newValue.replace(/["]/g, '\\"') + '"';
    } else {
      newValueSent = newValue;
    }
    let graphQL = 'mutation { deal(id:' + this.props.match.params.id + ', ';
    graphQL += fieldName + ':' + newValueSent + ') { ' + fieldName + ' } }';

    let queryURL = apiDealShow;
    let data = 'data=' + encodeURIComponent(graphQL);
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then((data) => {
        if (data['data']['deal'][fieldName] == newValue) {
          this.props.openToast(true, 'Votre modification a bien été prise en compte.');
          this.componentDidMount();
        } else {
          this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
        }
      })
      .catch(() => {
        console.log('erreur fetch UPDATE deal entity');
      });
  }

  removeInterlocutor() {
    let graphQL =
      'mutation { deal(id:' +
      this.state.dealId +
      ', removeInterlocutorId:' +
      this.state.interlocutorToRemoveId +
      '){id, interlocutors{ id }}}';

    let queryURL = apiDealShow;
    let data = 'data=' + encodeURIComponent(graphQL);

    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['deal']['interlocutors'].length !== this.state.dealInterlocutors.length) {
            this.props.openToast(true, "L'interlocuteur a bien été retiré.");
            this.componentDidMount();
          } else {
            this.props.openToast(false, 'Erreur lors de la modification. Veuillez réessayer.');
          }
        }.bind(this)
      )
      .catch(() => {
        console.log('erreur fetch UPDATE deal entity');
      });
  }

  linkInterlocutorResult() {
    this.componentDidMount();
  }
}

export default withAuth(DisplayDeal);
